// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1j2wu","large":"styles_large__2ap8X"};